export const signUpStatus = (userData) => {
  if (userData?.deposit?.status === 1 || userData?.full?.status === 1) {
    return 'Made payment';
  }
  if (userData?.deposit?.status === 0 || userData?.full?.status === 0) {
    return 'Payment details only';
  }
  return 'Basic info only';
};

export const havePaid = (userData) => {
  if (userData?.payment_details) {
    if (
      userData?.payment_details?.full?.succeeded_time &&
      userData?.payment_details?.complete_payment
    ) {
      return 'Enrolled';
    } else if (userData?.payment_details?.deposit?.succeeded_time) {
      return 'Enrolled';
    } else {
      return 'Add to Cart';
    }
  } else {
    if (userData?.student_details) {
      if (userData?.student_details?.course_offer_type) {
        if (
          userData?.student_details?.course_offer_type !== 'freeWorkshop'
        ) {
          return 'Lead';
        } else {
          return false;
        }
      }
    }
  }
  return true;
};

export const getPaymentMode = (userData) => {
  if (userData?.payment_details) {
    if (userData?.payment_details?.full?.succeeded_time) {
      return userData?.payment_details?.full?.mode;
    } else if (userData?.payment_details?.deposit?.succeeded_time) {
      return userData?.payment_details?.deposit?.mode;
    }
  }
  return '';
};

export const haveCompletedPayment = (userData) => {
  return userData?.complete_payment === 1;
};

export const getPurchaseValue = (userData) => {
  if (userData?.deposit && userData?.invoice) {
    return (userData.deposit?.amount + userData.invoice?.amount) / 100;
  } else if (userData?.full) {
    return userData.full.amount / 100;
  } else if (userData?.deposit) {
    return userData.deposit.amount / 100;
  }
};
